import { render } from "./BlackCircleButton.vue?vue&type=template&id=3329a5db&scoped=true"
import script from "./BlackCircleButton.vue?vue&type=script&lang=js"
export * from "./BlackCircleButton.vue?vue&type=script&lang=js"

import "./BlackCircleButton.vue?vue&type=style&index=0&id=3329a5db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3329a5db"]])

export default __exports__